import React from 'react';
import {Provider} from 'react-redux';
// import ReactGA from 'react-ga';
import store from './store';
import './index.scss';
import './styles/main.scss';
// import "./darkMode.scss";
import './assets/stylesheets/sf-pro.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import MaintenancePage from 'views/Maintenance';
import moment from 'moment';
import {HelmetProvider} from 'react-helmet-async';
import {createRoot} from 'react-dom/client';

let isMaintenanceTime = false;
// let singaporeTime = moment.utc().add(8, 'h');
// if (singaporeTime.hour() < 22 && singaporeTime.date() === 26) {
//     isMaintenanceTime = true;
// }
// ReactGA.initialize('UA-148889528-1', {
//     debug: true,
//     titleCase: false,
// });
// ReactGA.pageview('/');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <Provider store={store}>
        {!isMaintenanceTime ? (
            <HelmetProvider>
                <App />
            </HelmetProvider>
        ) : (
            <MaintenancePage />
            // <div className="maintenance-coming-soon">
            //     Coming Soon.
            //     <br /> Under Scheduled Maintenance.
            //     <br />
            //     The application will be up by 4:30 SGT.
            // </div>
        )}
    </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
